import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getLibrariesData } from '../services/Libraries.js';
import { useEffect, useMemo, useState } from 'react';
import GeneralLibraries from './Libraries/GeneralLibraries.js';
import MyAccordionNested from '../components/MyAccordionNested.js';
import Section1 from './Libraries/Section1/Section1.js';
import Section2 from './Libraries/Section2/Section2.js';
import Section3 from './Libraries/Section3/Section3.js';
import Section4 from './Libraries/Section4/Section4.js';
import BookInfo from './Libraries/BookInfo/BookInfo.js';
import AuctionInfo from './Libraries/AuctioInfo/AuctionInfo.js';
import ResearchCategories from './Libraries/ResearchCategories/ResearchCategories.js';
import Keywords from './Libraries/Keywords/Keywords.js';
import Dimensions from './Libraries/Dimensions/Dimensions.js';
import { useSelector } from 'react-redux';
import MyTabsNested from '../components/MyTabsNested.js';
import Highlights from './Libraries/Highlights/Highlights.js';

const EditLibraryRecord = () => {
  const { alias, libraryAlias } = useParams();
  const isTabDisabled = alias ? false : true;
  const mainLibraryAlias = libraryAlias ? libraryAlias : alias;
  const [libraryTitle, setLibraryTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  const type=window.location.pathname.split('/')[1];

  // Define tab configuration
  const tabs = useMemo(() => [
    {
      id: "general",
      title: "General",
      Component: GeneralLibraries,
      subTabs: [
        { id: "quadrant-1", title: "Quadrant-1", Component: Section1 },
        { id: "quadrant-2", title: "Quadrant-2", Component: Section2, isDisabled: isTabDisabled },
        { id: "quadrant-3", title: "Quadrant-3", Component: Section3, isDisabled: isTabDisabled },
        { id: "quadrant-4", title: "Quadrant-4", Component: Section4, isDisabled: isTabDisabled },
        { id: "book-info", title: "Book Info", Component: BookInfo, isDisabled: isTabDisabled },
        { id: "auction-info", title: "Auction Info", Component: AuctionInfo, isDisabled: isTabDisabled },
        { id: "researchCategories", title: "Research Categories", Component: ResearchCategories, isDisabled: isTabDisabled },
        { id: "keywords", title: "Keywords", Component: Keywords, isDisabled: isTabDisabled },
        { id: "dimensions", title: "Dimensions", Component: Dimensions, isDisabled: isTabDisabled },
        { id: "Highlight", title: "Highlight", Component: Highlights, isDisabled: isTabDisabled },
      ]
    }
  ], [isTabDisabled]);

  // Fetch library title
  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (mainLibraryAlias) {
          const result = await getLibrariesData(mainLibraryAlias, 'title', type);
          if (result) {
            const citation = result?.data?.[0]?.bibliographic_citation;
            const title = result?.data?.[0]?.title;
            setLibraryTitle(citation || title);
          }
        }
      } catch (error) {
        console.error('Error fetching library data:', error);
      }
    };
    getBasicData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainLibraryAlias]);

  // Determine if we're in research category context
  const isResearchCategory = !!libraryAlias;

  // Define base path based on context
  const basePath = isResearchCategory
    ? `/research-categories/${libraryAlias}/research-centre/library/${mainLibraryAlias}`
    : `/libraries/${mainLibraryAlias}`;

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);

    if (!location.pathname.includes('/create')) {
      // Determine the expected tab position based on URL structure
    const tabPosition = isResearchCategory ? 5 : 2; // 0-indexed position of tab in path parts

    // Check if path already has tab and subtab
      const hasTab = pathParts?.length > tabPosition;
      const hasSubtab = pathParts?.length > tabPosition + 1;

      if (!hasTab || !hasSubtab) {
        // Redirect to default tab/subtab
        const defaultPath = `${basePath}/${tabs[0].id}/${tabs[0].subTabs[0].id}`;
        navigate(defaultPath, { replace: true });
      }
    }
  }, [basePath, location.pathname, navigate, tabs, isResearchCategory]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
      <Box>
        <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{libraryTitle}</Text>
      </Box>
      {previewEnabled ? (
        <MyAccordionNested
          orientation="vertical"
          list={tabs}
          urlBasePath={basePath}
          includeALias={false} // Don't add alias again since it's in basePath
          tabSegmentPosition={isResearchCategory ? 5 : 2}
          subTabSegmentPosition={isResearchCategory ? 6 : 3}
        />
      ) : (
        <MyTabsNested
          orientation="vertical"
          list={tabs}
          urlBasePath={isResearchCategory
            ? `/research-categories/${libraryAlias}/research-centre/library/${mainLibraryAlias}`
            : `/libraries/${mainLibraryAlias}`}
          includeALias={false}
          tabSegmentPosition={isResearchCategory ? 5 : 2}
          subTabSegmentPosition={isResearchCategory ? 6 : 3}
        />
      )}
    </Stack>
  );
};

export default EditLibraryRecord;